import axios from "axios";
import { getHeaders } from "../utility/getHeader";


const fetchData = async (tblname, setData, orderby, where) => {
    // Build the URL dynamically based on the provided parameters
    let url = `/fetchdata`;
    if (tblname) {
        url += `/${tblname}`;
    }
    
    // Default orderby if not provided
    const orderByParam = orderby || 'id';
    url += `/${orderByParam}`;
    
    if (where) {
        let whereParams;
        if (typeof where === 'object') {
            // Convert object to URLSearchParams string
            whereParams = new URLSearchParams(where).toString();
        } else {
            // Handle string where conditions
            whereParams = where;
        }
        url += `/${whereParams}`;
    }
    // console.log(url);
    // if(tblname==="final_bill")
    // {
    //     console.log("Fetch url data");
    //     console.log(url);

    // }
    
    const response = await axios.get(url, getHeaders());

    // If a setData function is provided, update the state with the fetched data
    if (setData && typeof setData === 'function') {
        setData(response.data.data)
       console.log(response.data.data);
        if(tblname==="expense_ledger")
            {
                console.log("getch expense ledger data:");
       console.log(response.data.data);
            }
    }
   // console.log("fetchdata data:");
      // console.log(response.data.data);
    return response.data.data;
}
const fetchdatanotequal = async (tblname, setData, orderby, where) => {
    // Build the URL dynamically based on the provided parameters
    let url = `/fetchdatanotequal`;
    if (tblname) {
        url += `/${tblname}`;
    }
    if (orderby) {
        url += `/${orderby}`;
    }
    if (where) {
        const whereParams = new URLSearchParams(where).toString();
        url += `/${whereParams}`;
        
       
    }
    //console.log(url);
    // if(tblname==="final_bill")
    // {
    //     console.log("Fetch url data");
    //     console.log(url);

    // }
    
    const response = await axios.get(url, getHeaders());

    // If a setData function is provided, update the state with the fetched data
    if (setData && typeof setData === 'function') {
        setData(response.data.data)
      //  console.log(response.data.data);
    //     if(tblname==="final_bill")
    //         {
    //             console.log("getch final bill data:");
    //    console.log(response.data.data);
    //         }
    }
    return response.data.data;
}



// ✅ Named export
export default fetchData;
export { fetchdatanotequal };

